import { render } from "./FiltreClicklink.vue?vue&type=template&id=edada2ce"
import script from "./FiltreClicklink.vue?vue&type=script&lang=ts"
export * from "./FiltreClicklink.vue?vue&type=script&lang=ts"
script.render = render

export default script